import RoomType from '../roomType';
export default class Livingroom extends RoomType {
  constructor() {
    super();
    this.id = 'Livingroom';
    this.name = "Stue";
    this.icon = "mdi-sofa";
    this.stateQuestions.questions.push(
      {
        'id': 'windows',
        'title': 'Vinduer og karmer',
        'active': true,
        'value': -1
      }
    );
    this.contentTypes.options.unshift(
      {
        'id': 'cable_tv',
        'title': 'Uttak til kabel-TV',
        'active': true,
        'value': -1
      },
      {
        'id': 'internet',
        'title': 'Uttak til internett',
        'active': true,
        'value': -1
      },
      {
        'id': 'sofa',
        'title': 'Plass til sofagruppe',
        'active': true,
        'value': -1
      },
      {
        'id': 'dining',
        'title': 'Plass til spisebord',
        'active': true,
        'value': -1
      },
      {
        'id': 'balcony',
        'title': 'Utgang til balkong/terrasse',
        'active': false,
        'value': -1
      },

    );
  }
}